import type { MaterialDataObject } from '@powerplay/core-minigames'
import { gatesManager } from '../GatesManager'
import { hill } from '../Hill'
import { checkpointManager } from '../modes/training/CheckpointsManager'
import {
  MaterialsNames,
  TexturesNames
} from '../types'

/**
 * Konfig pre materialy
 */
export const materialsConfig: MaterialDataObject = {
  [MaterialsNames.skier]: {
    meshesArray: [
      'body', 'pole_L', 'pole_R', 'ski_L', 'ski_R', 'w_body', 'w_pole_L', 'w_pole_R',
      'w_ski_L', 'w_ski_R'
    ],
    textureName: TexturesNames.skierClothes,
    playerIndex: 0
  },
  [MaterialsNames.hill]: {
    textureName: TexturesNames.hill,
    lightmap: TexturesNames.lightmapHill,
    vertexColors: true,
    isDefault: true
  },
  [MaterialsNames.transparent]: {
    alpha: 0.5,
    textureName: TexturesNames.transparent,
    meshesArray: [
      'Trees', 'FinishZoneStandingAudience', 'FinishZoneSittingAudience',
      'UpperTrackAudience', 'MidZoneStandingAudience', 'UpperTrackAudience002'
    ],
    lightmap: TexturesNames.lightmapHill
  },
  [MaterialsNames.transparentSafetyNet]: {
    textureName: TexturesNames.transparentSafetyNet,
    transparent: true,
    meshesArray: [hill.FENCE_NAME]
  },
  [MaterialsNames.ads]: {
    textureName: TexturesNames.ads,
    meshesArray: ['Ads'],
    lightmap: TexturesNames.lightmapHill
  },
  [MaterialsNames.flags]: {
    textureName: TexturesNames.flags,
    meshesArray: ['Flags'],
    lightmap: TexturesNames.lightmapHill
  },
  [MaterialsNames.track]: {
    textureName: TexturesNames.track,
    meshesArray: [
      'TrackFinish', 'TrackBridge', 'Track', 'TerrainClose', 'TerrainFar', 'TrackLines'
    ],
    lightmap: TexturesNames.lightmapHill,
    vertexColors: true
  },
  [MaterialsNames.staticPeople]: {
    textureName: TexturesNames.staticPeople,
    meshesArray: ['StaticPeople', 'StaticPeopleUP', 'StaticPeopleUP001']
  },
  [MaterialsNames.onlyVertexColor]: {
    vertexColors: true,
    meshesArray: [checkpointManager.CHECKPOINT_MESH_NAME]
  },
  [MaterialsNames.checkpointGlow]: {
    meshesArray: [checkpointManager.CHECKPOINT_GLOW_MESH_NAME],
    transparent: true,
    textureName: TexturesNames.marker,
    opacity: 0.2
  },
  [MaterialsNames.gates]: {
    textureName: TexturesNames.gates,
    meshesArray: [
      'Branka1RIGHT', 'Branka0RIGHT', 'BrankyCombined', 'Branka1LEFT', 'Branka0LEFT',
      gatesManager.ANIMATED_GATE_MESH_LEFT_NAME, gatesManager.ANIMATED_GATE_MESH_RIGHT_NAME
    ]
  },
  [MaterialsNames.startCabin]: {
    textureName: TexturesNames.startCabin,
    meshesArray: ['StartCabin'],
    lightmap: TexturesNames.lightmapHill
  }
}
